module.exports = __webpack_public_path__ + "static/media/avatar22.0b1eabc3.png";